import { Injectable } from '@angular/core';
import { DataService as CoreDataService, ReadObjectTypeInfoModel } from '@barthauer/abc/core/data';
import { OPathOperator } from '../models/operators.model';

@Injectable({
  providedIn: 'root',
})
export class OperatorsService {
  public oPathOperators: OPathOperator[];


  constructor(private coreDataService: CoreDataService) {
    const queryFunction: ReadObjectTypeInfoModel = new ReadObjectTypeInfoModel();
    this.coreDataService.executeOperatorsInfoQuery(queryFunction).subscribe((data: any) => {
      this.oPathOperators = [];
      data.Operators.forEach((operator) => {
        this.oPathOperators.push(new OPathOperator(operator));
      });
    });
  }
}
